import { useEffect, useState } from 'react'
import { get } from '../../../lib/api'
import { handleEventLog, redirectToNovelLinkHandler, redirectToShowLinkHandler } from '../../../lib/utils'

export default function HandleContestDetails(titleId, contestType) {
  const [contestsData, updateContestData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const handleJoinContestBtn = (screenName, metaDataObj) => {
    const contestId = contestsData.contest_id
    const defaultReferrer = `contest_${contestsData.contest_title}`
    window.localStorage.setItem('contestId', contestId)
    handleEventLog(screenName || 'writer_contest', 'button_click', {
      route: window.location.pathname + window.location.search + window.location.hash,
      button: 'join_contest_button',
      entity_id: contestsData.contest_id,
      ...metaDataObj
    })
    const queryString = window.location.search
    const params = new URLSearchParams(queryString)
    const referrer = params.get('referrer') || defaultReferrer
    if (window.localStorage.getItem('uid')) {
      window.location.href = `/shows/novels/?referrer=${referrer}&medium=banner&campaign=${titleId}&open-new=1`
    } else if(contestsData?.locale === 'US'){
      window.location.href = `/onboarding?referrer=${referrer}&medium=banner&campaign=${titleId}`
    }else {
      window.location.href = `/?referrer=${referrer}&medium=banner&campaign=${titleId}`
    }
  }

  const handleEarnButtonClick = (isUSContest) => {
    if(localStorage.getItem('uid')){
      window.location.href = `/writers-benefit`
    }
    else if(isUSContest){
      window.location.href = `/author-welfare-usa`
    }else{
      window.location.href = `/author-welfare/hindi`
    }
  }

  const checkContestStatus = (contestDate) => {
    return new Date(contestDate) >= new Date()
  }

  const toggleAccordionTextHandler = (e) => {
    const accordionTextElement = e.currentTarget.nextElementSibling
    accordionTextElement.style.maxHeight
      ? (accordionTextElement.style.maxHeight = null)
      : (accordionTextElement.style.maxHeight =
          accordionTextElement.scrollHeight + 'px')
    e.currentTarget.classList.toggle('open')
  }

  const toggleExtraInfoHandler = (e) => {
    const extraInfoElement = e.currentTarget.previousElementSibling
    if (
      extraInfoElement.style.maxHeight !==
      extraInfoElement.scrollHeight + 'px'
    ) {
      extraInfoElement.style.maxHeight = extraInfoElement.scrollHeight + 'px'
      extraInfoElement.style.webkitTextFillColor = `var(--Text500)`
    } else {
      extraInfoElement.style.maxHeight = '6rem'
      extraInfoElement.style.webkitTextFillColor = `transparent`
    }
    e.currentTarget.classList.toggle('open')
  }

  const showNovelHandler = (id, isAudiobook) => {
    handleEventLog('writer_contest', 'button_click', {
      route: window.location.pathname + window.location.search + window.location.hash,
      button: 'read_now_button',
    })
    if(isAudiobook){
      redirectToShowLinkHandler(id)
    }else{
      redirectToNovelLinkHandler(id)
    }
  }

  function fetchData(contestId) {
    get(`/content_api/contests/${contestId}/?is_novel=1`)
      .then((res) => {
        updateContestData(res)
      })
      .catch(() => {
        updateContestData([])
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    if (titleId && contestType === 'dynamic') {
      const id = titleId.split('-').pop()
      if (id) {
        fetchData(id)
        return
      }
      updateContestData([])
    }
  }, [contestType])

  return [
    contestsData,
    isLoading,
    handleJoinContestBtn,
    showNovelHandler,
    handleEarnButtonClick,
    toggleAccordionTextHandler,
    toggleExtraInfoHandler,
    checkContestStatus,
  ]
}
